import React from 'react'
import { CookieBannerVisibility } from 'src/Libs/cookie-banner/types'

interface CookieContext {
  displayCookieBanner: CookieBannerVisibility
  setDisplayCookieBanner: (value: CookieBannerVisibility) => void
  isOnProfilePage: boolean
  setIsOnProfilePage: (value: boolean) => void
}

/**
 * Context for displaying the cookie banner
 */
export const CookieBannerContext = React.createContext<CookieContext | undefined>(undefined)
